module.exports = __webpack_public_path__ + "img/signup_mask-top.4b84729b.svg";